/*global moment _ */
import './style.less';
import seeCalculationInfoTemplate from './seeCalculationInfo.html';
import seeCalculationInfoController from './seeCalculationInfoController.js';
import { defaultEventProjection } from 'assets/projections';

export default function($scope, $log, $q, $uibModal, $stateParams, RegulatorClass, ApiClass) {
  'ngInject';

  $scope.uid = $stateParams.id;
  $scope.selectedStatus = 'Exceeding Benchmark';
  $scope.resultsQueried = false;
  $scope.upcomingRenewals = [];
  $scope.upcomingAdminEvents = [];
  $scope.exceedingBenchMark = 0;
  $scope.atRisk = 0;
  $scope.behindBenchmark = 0;

  $scope.findElement = function($event) {
    if ($($event.target).attr('fill') === '#72c02c') {
      $scope.selectedStatus = 'Exceeding Benchmark';
    } else if ($($event.target).attr('fill') === '#f8ac59') {
      $scope.selectedStatus = 'Behind Benchmark';
    } else if ($($event.target).attr('fill') === '#ed5565') {
      $scope.selectedStatus = 'At Risk';
    }
  };

  $scope.statusColorDict = {
    'Exceeding Benchmark': 'primary',
    'Behind Benchmark': 'warning',
    'At Risk': 'danger'
  };

  $scope.statusDesDict = {
    'Exceeding Benchmark':
      '<p>Wow, these folks deserve to pat themselves on the back!  Individuals who are exceeding the benchmark are ahead of where they need to be based upon the number of hours they have at whatever point they’re at in their CPE renewal cycle.</p> <p>This is based on an average number of hours they need to earn to hit their cycle requirements.  You can imagine this as a line that starts at “0” on the first day of their cycle and extends to the required number of hours on the last day of their cycle.</p>',
    'Behind Benchmark':
      '<p>Keep an eye out, these folks are falling a bit behind where they should be at this point in their CPE cycle.  They aren’t in danger yet but should aim to catch up to the benchmark as soon as they’re able.  If they have courses coming up soon they should be able to catch up quickly.</p> <p>This is based on an average number of hours they need to earn to hit their cycle requirements.  You can imagine this as a line that starts at “0” on the first day of their cycle and extends to the required number of hours on the last day of their cycle.<p>',
    'At Risk':
      '<p>Uh oh!  These folks have some work to do to catch up.  They’re far enough behind their benchmark for this time of the year that they should start to be concerned about needing to scramble at the end of their cycle – especially if it’s not too far away.</p> <p>This is based on an average number of hours they need to earn to hit their cycle requirements.  You can imagine this as a line that starts at “0” on the first day of their cycle and extends to the required number of hours on the last day of their cycle.</p>'
  };
  $scope.calculationToolTip = 'Click to see more information about how we calculate compliance status';

  $scope.statusObj = {
    'Behind Benchmark': [],
    'At Risk': [],
    'Exceeding Benchmark': []
  };

  const qArr = [
    RegulatorClass.loadRegulators(),
    ApiClass.scan(
      ApiClass.usersGet,
      {},
      {},
      {
        queryParams: {
          manage: true,
          'include:type': 'basic',
          'scan:limit': 2000
        }
      }
    ),
    ApiClass.scan(
      ApiClass.usersLicensesGet,
      {},
      {},
      {
        queryParams: { 'filter:latest': true, manage: true, 'filter:basic': true, 'scan:limit': 4000 }
      }
    ),
    ApiClass.eventsGet(
      { eventType: false, pastEvents: false },
      {},
      {
        queryParams: {
          internal: true,
          ...defaultEventProjection.reduce((acc, prop) => {
            acc[`projection:${prop}`] = 1;

            return acc;
          }, {})
        }
      }
    )
  ];

  $q.all(qArr)
    .then(([regulators, { items: employees }, { items: compliance }, { data: { events } }]) => {
      const arr = compliance;
      const employeesDict = _.keyBy(employees, 'profile_uid');
      $scope.adminEventsArr = events;
      $scope.regulators = regulators.objCurrent;
      $scope.employees = employeesDict;
      for (let i = 0; i < arr.length; i++) {
        if (new Date(Date.now()) < new Date(arr[i].cycle_date)) {
          arr[i].sortDate = new Date(arr[i].cycle_date).getTime();
          arr[i].first =
            employeesDict[arr[i].profile_uid] && employeesDict[arr[i].profile_uid].first
              ? employeesDict[arr[i].profile_uid].first
              : '( NO Name )';
          arr[i].last =
            employeesDict[arr[i].profile_uid] && employeesDict[arr[i].profile_uid].last
              ? employeesDict[arr[i].profile_uid].last
              : '( NO Name )';
          $scope.upcomingRenewals.push(arr[i]);
          if (arr[i].status === 'Behind Benchmark') {
            $scope.statusObj['Behind Benchmark'].push(arr[i]);
            $scope.behindBenchmark = $scope.behindBenchmark + 1;
          }
          if (arr[i].status === 'At Risk') {
            $scope.statusObj['At Risk'].push(arr[i]);
            $scope.atRisk = $scope.atRisk + 1;
          }
          if (arr[i].status === 'Exceeding Benchmark') {
            $scope.statusObj['Exceeding Benchmark'].push(arr[i]);
            $scope.exceedingBenchMark = $scope.exceedingBenchMark + 1;
          }
        }
      }

      $scope.adminEventsArr.forEach(event => {
        if (event.delivery_date != 'Invalid Date')
          event.timeDiff = moment(new Date(), 'YYYY-MM-DD HH:mm').diff(
            moment(new Date(event.delivery_date), 'YYYY-MM-DD HH:mm'),
            'days'
          );
        event.sort_date = new Date(event.delivery_date).getTime();
        if (event.timeDiff > -50 && event.timeDiff < 6 && (!event.report_submitted && !event.archive)) {
          $scope.upcomingAdminEvents.push(event);
        }
      });

      $scope.donutData = [
        { label: 'Exceeding Benchmark', color: '#72C02C', value: $scope.exceedingBenchMark },
        { label: 'Behind Benchmark', color: '#F8AC59', value: $scope.behindBenchmark },
        { label: 'At Risk', color: '#ED5565', value: $scope.atRisk }
      ];
      $scope.getters = {
        name: val => {
          return $scope.employees[val.profile_uid].last;
        },
        license: val => {
          return $scope.regulators[val.reg_id].name;
        },
        date: val => {
          return moment(val.cycle_date, 'x').unix();
        }
      };
      $scope.tableHeaders = [
        { title: 'Last', sort: 'last', width: 'col-lg-2 col-md-2 col-sm-2 col-xs-2' },
        { title: 'First', sort: 'first', width: 'col-lg-2 col-md-2 col-sm-2 col-xs-2' },
        { title: 'License', width: 'col-lg-3 col-md-3 col-sm-3 col-xs-3' },
        { title: 'Deadlines', sort: 'sortDate', default: true, width: 'col-lg-2 col-md-2 col-sm-2 col-xs-2' },
        { title: 'Status', width: 'col-lg-3 col-md-3 col-sm-3 col-xs-3' }
      ];
      $scope.resultsQueried = true;
    })
    .catch(error => {
      $log.error(error);
      throw error;
    });

  $scope.seeCalculationInfo = selectedStatus => {
    $uibModal.open({
      backdrop: true,
      template: seeCalculationInfoTemplate,
      controller: seeCalculationInfoController(selectedStatus)
    });
  };
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/dashboard/index.js